import { render } from "./FloatingWindow.vue?vue&type=template&id=4c250257&ts=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=ts"
export * from "./FloatingWindow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
